/**
 * User: Faris
 * Date: 5/24/13
 * Time: 3:24 PM
 */

requirejs.config({
  baseUrl: '/library/js/',
  waitSeconds: 0,
  paths: {
    backbone: '../../bower_components/backbone/backbone',
    underscore: '../../bower_components/underscore/underscore',
    'es5-shim': '../../bower_components/es5-shim/es5-shim',
    greensock: '../../bower_components/greensock/src/uncompressed/TweenMax',
    hammerjs: '../../bower_components/hammerjs/hammer',
    jquery: '../../bower_components/jquery/dist/jquery',
    'jquery-maskedinput': '../../bower_components/jquery-maskedinput/dist/jquery.maskedinput',
    'jquery-mousewheel': '../../bower_components/jquery-mousewheel/jquery.mousewheel',
    'jquery-placeholder': '../../bower_components/jquery-placeholder/jquery.placeholder',
    'jquery.browser': '../../bower_components/jquery.browser/dist/jquery.browser',
    'jquery.serializeJSON': '../../bower_components/jquery.serializeJSON/jquery.serializejson',
    'malihu-custom-scrollbar-plugin': '../../bower_components/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar',
    modernizr: '../../bower_components/modernizr/modernizr',
    'moment-range': '../../bower_components/moment-range/lib/moment-range',
    moment: '../../bower_components/moment/moment',
    parsleyjs: '../../bower_components/parsleyjs/dist/parsley',
    requirejs: '../../bower_components/requirejs/require',
    select2: '../../bower_components/select2/select2',
    'underscore.string': '../../bower_components/underscore.string/lib/underscore.string',
    'jquery-serializeJSON': '../../bower_components/jquery-serializeJSON/karma.conf',
    'jquery-unveil': '../../bower_components/jquery-unveil/jquery.unveil',
    'jquery-ui': '../../bower_components/jquery-ui/jquery-ui',
    'jquery-ui-core': '../../bower_components/jquery-ui/ui/core',
    'jquery-ui-datepicker': '../../bower_components/jquery-ui/ui/datepicker',
    'requirejs-text': '../../bower_components/requirejs-text/text',
    text: '../../bower_components/requirejs-text/text',
    almond: '../../bower_components/almond/almond',
    iscroll: '../../bower_components/iscroll/build/iscroll',
    iCheck: '../../bower_components/iCheck/icheck.min',
    clndr: '../../bower_components/clndr/clndr.min',
    respond: '../../bower_components/respond/dest/respond.src',
    selectivizr: '../../bower_components/selectivizr/selectivizr',
    jcf: '../../bower_components/jcf/js/jcf',
    webcomponentsjs: '../../bower_components/webcomponentsjs/webcomponents'
  },
  shim: {
    backbone: [
      'jquery',
      'underscore',
      'hammerjs'
    ],
    iCheck: [
      'jquery'
    ],
    jcf: {
      deps: [
        'jquery'
      ],
      exports: 'jcf'
    },
    'jquery-ui': [
      'jquery'
    ],
    'jquery-maskedinput': [
      'jquery'
    ],
    'jquery-mousewheel': [
      'jquery'
    ],
    'jquery-placeholder': [
      'jquery'
    ],
    'jquery.browser': [
      'jquery'
    ],
    'jquery.serializeJSON': [
      'jquery'
    ],
    'jquery-unveil': [
      'jquery'
    ],
    'malihu-custom-scrollbar-plugin': [
      'jquery'
    ],
    'moment-range': [
      'moment'
    ],
    parsleyjs: [
      'jquery'
    ],
    select2: [
      'jquery'
    ],
    'underscore.string': [
      'underscore'
    ]
  },
  map: {
    'jquery-ui-datepicker': {
      core: 'jquery-ui-core'
    }
  },
  packages: [

  ]
});
define("config", function(){});

